import React, { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { LOGO_URL } from "@/lib/assets";

const links = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/services", label: "Services" },
  { to: "/schools", label: "For Schools" },
  { to: "/certifications", label: "Certifications" },
  { to: "/shop", label: "Shop" },
  { to: "/contact", label: "Contact" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <header
      data-testid="site-navbar"
      className="sticky top-0 z-50 glass-nav border-b border-brand-line/60"
    >
      <div className="px-6 md:px-12 lg:px-24 h-[72px] md:h-[88px] flex items-center justify-between">
        <Link
          to="/"
          data-testid="brand-logo-link"
          className="flex items-center gap-3 group"
        >
          <img
            src={LOGO_URL}
            alt="Nada's Kids Garden"
            className="h-14 md:h-16 w-auto object-contain transition-transform group-hover:rotate-[-3deg]"
          />
          <span className="hidden sm:block">
            <span className="block font-brand text-xl md:text-2xl text-brand-leafDeep leading-none">
              Nada's Kids Garden
            </span>
            <span className="block font-body text-[10px] md:text-[11px] tracking-[0.22em] uppercase text-brand-muted mt-1">
              by Nada Zahabi
            </span>
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className={({ isActive }) =>
                `relative text-sm font-body transition-colors ${
                  isActive
                    ? "text-brand-ink"
                    : "text-brand-muted hover:text-brand-ink"
                } ${isActive ? "after:content-[''] after:absolute after:left-0 after:right-0 after:-bottom-2 after:h-[3px] after:rounded-full after:bg-brand-sun" : ""}`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:block">
          <Link
            data-testid="nav-book-session-btn"
            to="/contact"
            className="rounded-full bg-brand-sun hover:bg-brand-sunDeep text-brand-ink px-6 py-3 text-sm font-medium transition-all hover:shadow-sunny"
          >
            Contact
          </Link>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          className="lg:hidden text-brand-ink"
          onClick={() => setOpen(!open)}
          aria-label="Menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="lg:hidden border-t border-brand-line/60 bg-brand-cream px-6 py-6 flex flex-col gap-4"
        >
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              onClick={() => setOpen(false)}
              data-testid={`mobile-nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className="text-brand-ink font-body"
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            data-testid="mobile-nav-book-btn"
            to="/contact"
            onClick={() => setOpen(false)}
            className="rounded-full bg-brand-sun text-brand-ink px-5 py-2.5 text-sm mt-2 self-start"
          >
            Contact
          </Link>
        </div>
      )}
    </header>
  );
};
